module.exports = __webpack_public_path__ + "static/media/NFBC.ffeab1a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/NFBC.svg
// module id = 110
// module chunks = 0